module.exports = __webpack_public_path__ + "img/home-01-434x642.f830f8c1.png";